module.exports = __webpack_public_path__ + "img/dropped-image-2.17977ca4.png";